import { render, staticRenderFns } from "./ComplaintDetailAppraise.vue?vue&type=template&id=56e17faa&scoped=true"
import script from "./ComplaintDetailAppraise.vue?vue&type=script&lang=js"
export * from "./ComplaintDetailAppraise.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDetailAppraise.vue?vue&type=style&index=0&id=56e17faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e17faa",
  null
  
)

export default component.exports